document.addEventListener('click', event => {
  const anchor = event.target.closest('a[href]');
  if (!anchor) return;
  const preview = new URL(location.href).searchParams.get('preview_theme_id');
  const url = new URL(anchor.href, location.href);
  if (preview && url.origin === location.origin && !url.pathname.startsWith('/checkout') && !url.pathname.includes('/cart/change')) {
    url.searchParams.set('preview_theme_id', preview);
    anchor.href = url.href;
  }
});
